import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';

export class SineLookup implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];

	constructor() {
		let steps: number = 360;
		let amplitude: number = 1.4;
		let frequency: number = 40;
		let i: number = 0;
		let exit: boolean = false;
		let xStep: number = 1;
		let scaleAlphaValue: number;
		let x: number = 0;
		let y: number = 0;

		while (i < steps || !exit) {
			y = amplitude * Math.sin(x / frequency);
			x += xStep;
			scaleAlphaValue = 1 * ((y + amplitude) / (amplitude * 2));
			this._path.push({
				x: x,
				y: y,
				scale: scaleAlphaValue,
				alpha: scaleAlphaValue,
				rotation: 0
			});
			i++;
			if (i >= steps) {
				if (y > 0 && y < 0.01) {
					exit = true;
				}
			}
		}
	}

	public get type(): LookupType {
		return LookupType.SINE;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
